import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchiveDocCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4438_107697)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2 32L9 18H39L46 32L24 42L2 32Z",
				fill: "#252977"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 43C23.859 43 23.718 42.97 23.586 42.91L1.586 32.91C1.338 32.798 1.148 32.59 1.057 32.333C0.967001 32.077 0.984001 31.795 1.105 31.552L8.105 17.552C8.275 17.214 8.621 17 9 17H39C39.379 17 39.725 17.214 39.895 17.553L46.895 31.553C47.017 31.796 47.034 32.078 46.943 32.334C46.852 32.59 46.661 32.798 46.414 32.911L24.414 42.911C24.282 42.97 24.141 43 24 43ZM3.358 31.519L24 40.901L44.642 31.519L38.382 19H9.618L3.358 31.519Z",
				fill: "#565CDE"
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter0_d_4438_107697)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M39 38H9C8.448 38 8 37.552 8 37V2C8 1.448 8.448 1 9 1H39C39.552 1 40 1.448 40 2V37C40 37.552 39.552 38 39 38Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.59 21.7662L17.42 17.9169L16 19.2185L21.59 24.3785L33.59 13.3015L32.18 12L21.59 21.7662Z",
				fill: "#9397EB"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31 31V36C31 36.552 30.552 37 30 37H18C17.448 37 17 36.552 17 36V31H2C1.448 31 1 31.448 1 32V46C1 46.552 1.448 47 2 47H46C46.552 47 47 46.552 47 46V32C47 31.448 46.552 31 46 31H31Z",
				fill: "#565CDE"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_4438_107697",
		x: -2,
		y: -5,
		width: 52,
		height: 57,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.171701 0 0 0 0 0.179687 0 0 0 0 0.191667 0 0 0 0.1 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_4438_107697"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_4438_107697",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4438_107697",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			fill: "white"
		})
	})] })]
});
export default SvgArchiveDocCheck;
